import { render } from "./reportEatServeTarget.vue?vue&type=template&id=01c22f4c"
import script from "./reportEatServeTarget.vue?vue&type=script&lang=js"
export * from "./reportEatServeTarget.vue?vue&type=script&lang=js"

import "./reportEatServeTarget.vue?vue&type=style&index=0&id=01c22f4c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__